/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function LabelsList(): JSX.Element {
  const history = useHistory();
  const url = `${API_URL}/products/labels/get`;
  const onRowClick = (rowInfo) => {
    history.push(`/labels/edit/${rowInfo.dataItem.id}`);
  };
  const StatefullGrid = withState(Grid, url, { onRowClick });

  return (
    <WhitePad>
      <TitleComponent
        title="Labels"
        titleRight="Create"
        onRightHandler={(): void => history.push('/labels/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid>
          <GridColumn field="width" title="Width (cm)" />
          <GridColumn field="height" title="Height (cm)" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
